module.exports = __webpack_public_path__ + "resources/2f647df6adf0f9337da5ed968d8d9ba3.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/bar-background-2.jpg
// module id = 210
// module chunks = 0